import React, { useState } from "react";
import CustomJS from "../../../components/BuilderComponents/CustomJS";
import Textarea from "../../../components/FormComponents/Textarea";
import Button from "../../../components/FormComponents/Button";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import { useAxiosContext } from "../../../context/AxiosContext";
import TimeProgressBar from "../../../components/BuilderComponents/TimeProgressBar";
import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";

const FieldCustomFunction = ({
  editFieldValidation,
  setEditFieldValidation,
  tableID = "",
  table_type = "statemachine",
  fieldData
}) => {
  const [isOpenAi, setIsOpenAi] = useState(false);

  const handleCustomJsChange = (e) => {
    setEditFieldValidation({ ...editFieldValidation, custom_js: e.target.value });
  };
  const updateCustomJs = (value) => {
    setEditFieldValidation({ ...editFieldValidation, custom_js: value });
    setIsOpenAi(false);
  };

  return (
    <>
      {tableID !== "publicform" ? (
        <div
          style={{
            height: "calc(250px - 50px)"
          }}
        >
          {!isOpenAi ? (
            <div className="position_relative">
              <ButtonActionIcon
                type="emoji_objects"
                style={{ position: "absolute", right: "82px" }}
                onClick={() => setIsOpenAi(true)}
              />
              <CustomJS
                inputString={editFieldValidation.custom_js}
                tableID={tableID}
                handleChange={(data) => setEditFieldValidation({ ...editFieldValidation, custom_js: data })}
                label="Custom Js"
                table_type={table_type}
              />
            </div>
          ) : (
            <>
              <CustomJS
                inputString={editFieldValidation.custom_js}
                tableID={tableID}
                handleChange={() => {}}
                label="Custom Js"
                table_type={table_type}
              />
            </>
          )}
        </div>
      ) : (
        <div className="builder_form">
          <Textarea
            label="Custom Js"
            value={editFieldValidation.custom_js || ""}
            name="custom_js"
            onChange={handleCustomJsChange}
          />
        </div>
      )}
      <BuilderModal isOpen={isOpenAi} onClose={() => setIsOpenAi(false)} modalName="Generate CustomJs">
        <GenerateCustomJs fieldData={fieldData} updateCustomJs={updateCustomJs} />
      </BuilderModal>
    </>
  );
};

export default FieldCustomFunction;

const GenerateCustomJs = ({ fieldData, updateCustomJs }) => {
  const { axiosInstance, handleError } = useAxiosContext();

  const [promptValue, setPromptValue] = useState("");
  const [isAiLoading, setIsAiLoading] = useState(false);

  const handleInputChange = (value) => {
    setPromptValue(value);
  };

  const generateCustomJS = async () => {
    try {
      setIsAiLoading(true);

      const config = {
        id: fieldData.id,
        type: fieldData.type,
        display: fieldData.label,
        user_prompt: promptValue
      };
      const { data } = await axiosInstance.post(`/ai/customjs/field`, config);
      setIsAiLoading(false);
      updateCustomJs(data);
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <>
      {isAiLoading ? (
        <TimeProgressBar totalTime={10000} interval={1000} />
      ) : (
        <div className="builder_form">
          <Textarea label="Enter Prompt" value={promptValue} onChange={(e) => handleInputChange(e.target.value)} />
          <div className="d_flex justify_end">
            <Button onClick={() => generateCustomJS()}>Generate</Button>
          </div>
        </div>
      )}
    </>
  );
};
